/* @flow */

const set = (selector: string, logo: string) => {
    Array.from(document.querySelectorAll(selector)).forEach((preview) => {
        if (preview instanceof HTMLImageElement) {
            preview.src = logo;
            return;
        }

        preview.innerHTML = '';
        preview.style.display = 'none';
        if (logo) {
            const img = document.createElement('img');
            img.src = logo;
            img.classList.add('img-fluid');
            img.classList.add('img-thumbnail');
            preview.appendChild(img);
            preview.style.display = '';
        }
    });
};

const remover = (seletor: string) => set(seletor, '');

export default { set, remover };
